import React, { useReducer, useContext, createContext } from 'react';

const CartStateContext = createContext();
const CartDispatchContext = createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD":
            return [...state, { id: action.id, productImage: action.productImage, productTitle: action.productTitle, productQuantity: action.productQuantity, productType: action.productType, productAmount: action.productAmount, productCount: action.productCount, originalAmount: action.productAmount}]
        case "REMOVE":
            let newArr = [...state]
            newArr.splice(action.index, 1)
            return newArr;
        
        case "SINGLE_UPDATE":
            return state.map((med) => {
                if (med.id === action.id && med.productCount < 10) {                            
                    const updatedProductCount = parseInt(med.productCount) + 1;
                    const updatedProductAmount = parseInt(med.productAmount) + parseInt(med.productAmount) / parseInt(med.productCount);
                    return { ...med, productCount: updatedProductCount, productAmount: updatedProductAmount};
                }
                return med;
            });

        case "SINGLE_REMOVE":
            return state.map((med) => {
                if (med.id === action.id && med.productCount > 1) {                        
                    const updatedProductCount = parseInt(med.productCount) - 1;
                    const updatedProductAmount = parseInt(med.productAmount) - parseInt(med.productAmount) / parseInt(med.productCount);     
                    return { ...med, productCount: updatedProductCount, productAmount: updatedProductAmount};
                }
                return med;
            });
        
        case "DROP":
            let empArray = []
            return empArray
        case "UPDATE":
            let arr = [...state];
            arr = arr.map((med) => {
                if (med.id === action.id) {
                    return {
                        ...med,
                        productCount: parseInt(action.productCount) + parseInt(med.productCount),
                        productQuantity: action.productQuantity,
                        productAmount: parseInt(action.productAmount) + parseInt(med.productAmount),
                    };
                }
                return med;
            });
            return arr;
        default:
            console.log("Error in Reducer");
    }
};

export const CartProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, []);

    return (
        <CartDispatchContext.Provider value={dispatch}>
            <CartStateContext.Provider value={state}>
                {children}
            </CartStateContext.Provider>
        </CartDispatchContext.Provider>
    )
};

export const useCart = () => useContext(CartStateContext);
export const useDispatchCart = () => useContext(CartDispatchContext);